import { API, URL } from "src/config/api";

export const getSingle = async (id) => {
  try {
    const response = await API.get(`${URL.users}/${id}`);
    return Promise.resolve(response.data);
  } catch (err) {
    return Promise.reject(err.response.data);
  }
};
